/* eslint-disable prettier/prettier */
import { apiService } from './api.service';
import { ApiResponse } from '../types/index';

/**
 * Types (align with backend)
 */
export interface ActivityType {
	id: string;
	title: string;
	color: string;
	icon?: string | null;
	description?: string | null;
	isactive: boolean;
	displayorder: number;
	metadata?: Record<string, any>;
	createdby: string;
	createdbyname?: string;
	createdat: string;
	updatedat: string;
}

export interface CreateActivityTypeRequest {
	title: string;
	color: string;
	icon?: string;
	description?: string;
	isactive?: boolean;
	displayorder?: number;
	metadata?: Record<string, any>;
}

export interface UpdateActivityTypeRequest {
	title?: string;
	color?: string;
	icon?: string | null;
	description?: string | null;
	isactive?: boolean;
	displayorder?: number;
	metadata?: Record<string, any>;
}

/**
 * Service
 */
export const activityTypeService = {
	/**
	 * Create
	 */
	async createActivityType(
		data: CreateActivityTypeRequest
	): Promise<ApiResponse<ActivityType>> {
		return apiService.post<ActivityType>('/activitytypes', data);
	},

	/**
	 * List
	 */
	async listActivityTypes(): Promise<ApiResponse<ActivityType[]>> {
		return apiService.get<ActivityType[]>('/activitytypes', {});
	},

	/**
	 * Get by ID
	 */
	async getActivityTypeById(id: string): Promise<ApiResponse<ActivityType>> {
		return apiService.get<ActivityType>(`/activitytypes/${id}`);
	},

	/**
	 * Update
	 */
	async updateActivityType(
		id: string,
		data: UpdateActivityTypeRequest
	): Promise<ApiResponse<ActivityType>> {
		return apiService.put<ActivityType>(`/activitytypes/${id}`, data);
	},

	/**
	 * Delete
	 */
	async deleteActivityType(id: string): Promise<ApiResponse<void>> {
		return apiService.delete<void>(`/activitytypes/${id}`);
	},

	/**
	 * Reorder
	 */
	async reorderActivityTypes(
		items: { id: string; displayorder: number }[]
	): Promise<ApiResponse<void>> {
		return apiService.put<void>('/activitytypes/reorder', {
			activitytypes: items,
		});
	},
};
